import { Breakpoints, PrimaryColors } from '@/common/theme/constants';
import { SxProps } from '@mui/material';
import {
  BannerTextLocation,
  BannerTextLocationVariants,
} from './utils/ItemCard.interface';

export const itemCardWrapper = ({
  selected,
  sx,
  isHover,
  generalBannerTextLocation,
}: {
  selected?: boolean;
  sx?: SxProps;
  isHover?: boolean;
  generalBannerTextLocation?: BannerTextLocation;
}): SxProps => ({
  position: 'relative',
  backgroundColor: PrimaryColors.obsidian,
  p:
    generalBannerTextLocation === BannerTextLocationVariants.Side
      ? '2rem 2rem 2rem 3rem'
      : '2rem',
  maxWidth: '300px',
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  alignItems: 'stretch',
  flexGrow: 1,
  justifyContent: 'flex-start',
  outline: selected ? '2px solid white' : '',
  boxShadow: selected ? `0px 0px 8.7px 0px ${PrimaryColors.white}` : '',
  cursor: isHover ? 'pointer' : 'default',
  boxSizing: 'border-box',
  ...sx,

  '&:hover': {
    outline: isHover ? `1px solid ${PrimaryColors.white}` : '',
    boxShadow: isHover ? `0px 0px 8.7px 0px ${PrimaryColors.white}` : '',
    backgroundColor: isHover ? PrimaryColors.charcoal : PrimaryColors.obsidian,
  },

  [`@media (max-width:${Breakpoints.md}px)`]: {
    p:
      generalBannerTextLocation === BannerTextLocationVariants.Side
        ? '2rem 2rem 2rem 2.5rem'
        : '2rem',
  },
});

export const styledItemContentWrapper: SxProps = {
  display: 'flex',
  gap: '25px',

  [`@media (min-width:${Breakpoints.sm}px)`]: {
    flexDirection: 'column',
    flexGrow: 1,
    gap: '18px',
  },
};

export const styledTextContent: SxProps = {
  flexGrow: 1,
  display: 'flex',
  gap: '18px',
  flexDirection: 'column',
};

export const styledCardTitle: SxProps = {
  textTransform: 'uppercase',
  fontWeight: '900',
};

export const styledPriceWrapper: SxProps = {
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'flex-end',
};

export const styledDescriptionText: SxProps = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  marginBottom: '0',
};

export const styledPriceAndHighlightedBenefits: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
};
